/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { API_URL } from 'config';

const axiosServices = axios.create({ baseURL: API_URL });

axiosServices.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('serviceToken');
        if (accessToken && config?.headers) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        const excludedPaths = ['/login', '/setup-2fa', '/verify-2fa'];
        const token = localStorage.getItem('serviceToken');

        if (error.response?.status === 401 && !excludedPaths.some((path) => window.location.pathname.includes(path))) {
            if (!token) {
                window.location.pathname = '/login';
            }
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);
export default axiosServices;
